import React from 'react'
import RtImage from './RtImage'

const RtImageList = ({ value: { images }}) => (
	<div className="grid md:grid-cols-2 gap-8 items-center p-8 bg-grounding-navy/5 <md:full-width">
		{images?.map((image, key) => (
			<RtImage value={image} notFullWidth key={key} />
		))}
	</div>
)

export default RtImageList
